import React from 'react';
import { useCart } from '../context/CartContext';
import { Link } from 'react-router-dom';
import './CartPage.css';

const CartPage = () => {
  const { items, removeFromCart, updateQuantity, clearCart, getCartTotal } = useCart();

  if (items.length === 0) {
    return (
      <div className="cart-page">
        <div className="container">
          <h1>سلة التسوق</h1>
          <div className="empty-cart">
            <h2>سلة التسوق فارغة</h2>
            <p>لم تقم بإضافة أي كتب إلى سلة التسوق بعد</p>
            <Link to="/books" className="btn btn-primary">
              تصفح الكتب
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-page">
      <div className="container">
        <h1>سلة التسوق</h1>
        
        <div className="cart-content">
          <div className="cart-items">
            {items.map(item => (
              <div key={item.id} className="cart-item">
                <div className="item-image">
                  <img src={item.image} alt={item.title} />
                </div>
                
                <div className="item-details">
                  <h3>{item.title}</h3>
                  <p className="item-author">{item.author}</p>
                  <p className="item-price">{item.price} جنيه</p>
                </div>
                
                <div className="item-quantity">
                  <button 
                    onClick={() => updateQuantity(item.id, item.quantity - 1)}
                    className="quantity-btn"
                  >
                    -
                  </button>
                  <span className="quantity">{item.quantity}</span>
                  <button 
                    onClick={() => updateQuantity(item.id, item.quantity + 1)}
                    className="quantity-btn"
                  >
                    +
                  </button>
                </div>
                
                <div className="item-total">
                  {(item.price * item.quantity).toFixed(2)} جنيه
                </div>
                
                <button 
                  onClick={() => removeFromCart(item.id)}
                  className="remove-btn"
                >
                  حذف
                </button>
              </div>
            ))}
          </div>
          
          <div className="cart-summary">
            <h3>ملخص الطلب</h3>
            <div className="summary-row">
              <span>المجموع الفرعي:</span>
              <span>{getCartTotal().toFixed(2)} جنيه</span>
            </div>
            <div className="summary-row">
              <span>الشحن:</span>
              <span>مجاني</span>
            </div>
            <div className="summary-row total">
              <span>المجموع الكلي:</span>
              <span>{getCartTotal().toFixed(2)} جنيه</span>
            </div>
            
            <div className="cart-actions">
              <button onClick={clearCart} className="btn btn-secondary">
                إفراغ السلة
              </button>
              <Link to="/checkout" className="btn btn-primary">
                إتمام الشراء
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartPage;
